var _style, _g, _g2, _polygon, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWinlose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "28 20 56 56",
    style: {
      enableBackground: "new 0 0 107.91 100.24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CC0031;}\n\t.st1{fill:#00BD75;}\n\t.st2{fill:#A4A4A4;}\n\t.st3{fill:#DADADA;}\n\t.st4{fill:#0F0742;}\n\t.st5{fill:#00683F;}\n\t.st6{fill:#8F0032;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "35.52,45.82 35.34,45.51 35.34,46.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "34.32,46.51 35.12,46.51 35.15,46.46 34.29,46.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "34.34,45.13 34.32,45.13 34.13,45.46 34.34,45.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "34.34,45.13 34.34,45.46 34.13,45.46 33.92,45.82 34.29,46.46 35.15,46.46 35.34,46.13 35.34,45.51 35.12,45.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "38.37,38.5 38.37,55.17 52.8,63.5 52.8,30.17  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "35.28,34.77 35.33,44.13 35.7,44.13 36.68,45.82 35.7,47.51 33.75,47.51 33.14,46.46 31.27,46.46 31.27,55.85 52.76,68.45 52.76,65.54 36.77,56.31 36.77,37.33 52.76,28.1 52.76,25.69 51.96,25.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "31.27,59.48 52.76,71.89 52.76,69.61 31.27,57.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "31.27,34.15 31.27,34.41 31.27,45.46 32.98,45.46 33.75,44.13 34.33,44.13 34.28,34.19 51.96,24.1 52.76,24.55 52.76,21.75 34.45,32.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "67.73,39.29 54.76,31.8 54.76,35.11 67.73,42.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "68.73,39.87 68.73,44.08 54.76,36.25 54.76,38.15 70.65,47.33 70.65,56.06 71.19,55.12 73.14,55.12 74.12,56.82 73.14,58.51 72.84,58.51 72.84,66.34 76.15,68.72 76.15,44.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "71.84,58.51 71.19,58.51 70.65,57.57 70.65,66.31 54.76,75.48 54.76,79.03 54.76,81.83 75.78,69.69 71.84,66.85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "30.52,33.43 30.27,33.57 30.27,35.07 30.27,45.46 30.77,45.46 31.27,45.46 31.27,34.41 31.27,34.15 34.45,32.32 52.76,21.75 52.76,21.17 52.76,20.59 46.03,24.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "31.27,57.01 30.77,56.71 30.27,56.42 30.27,60.06 52.76,73.04 52.76,72.46 52.76,71.89 31.27,59.48 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "31.27,55.85 31.27,46.46 30.77,46.46 30.27,46.46 30.27,55.26 30.77,55.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "68.73,38.72 68.73,39.29 68.73,39.87 76.15,44.15 76.15,68.72 76.65,69.09 77.15,69.45 77.15,43.57 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "75.78,69.69 54.76,81.83 54.76,82.41 54.76,82.99 76.67,70.33 76.22,70.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "67.73,38.72 67.73,38.14 54.76,30.65 54.76,31.22 54.76,31.8 67.73,39.29  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "72.56,56.12 71.76,56.12 71.65,56.32 72.67,56.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "72.96,56.82 72.84,56.61 72.84,57.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "71.84,57.51 71.84,57.32 71.65,57.32 71.76,57.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "71.84,57.51 72.56,57.51 72.84,57.02 72.84,56.61 72.67,56.32 71.65,56.32 71.36,56.82 71.65,57.32 71.84,57.32  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.28,34.19l0.05,9.94h-0.59l-0.77,1.33h-1.71h-0.5h-0.5v1h0.5h0.5h1.87l0.61,1.05h1.95l0.98-1.69 l-0.98-1.69h-0.37l-0.05-9.36l16.68-9.52l0.8,0.45v-1.15l-0.8-0.45L34.28,34.19z M35.34,46.13l-0.19,0.33l-0.03,0.05h-0.8 l-0.03-0.05l-0.37-0.64l0.21-0.36l0.19-0.33h0.01h0.78l0.22,0.38l0.18,0.31L35.34,46.13z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "30.77,55.55 30.27,55.26 30.27,56.42 30.77,56.71 31.27,57.01 52.76,69.61 52.76,68.45 31.27,55.85 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "67.73,38.72 67.73,39.29 67.73,42.37 54.76,35.11 54.76,36.25 68.73,44.08 68.73,39.87 68.73,39.29 68.73,38.72 67.73,38.14  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.65,69.09l-0.5-0.36l-3.3-2.38v-7.83h0.3l0.98-1.69l-0.98-1.69h-1.95l-0.54,0.94l-0.15,0.25h0.15v1H70.5 l0.15,0.25l0.54,0.94h0.66v8.35l3.94,2.84l0.45,0.32l0.44,0.32l0.23-0.13l0.25-0.14v-0.61L76.65,69.09z M71.65,57.32l-0.29-0.5 l0.29-0.5l0.11-0.19h0.8l0.11,0.19l0.17,0.29l0.12,0.21l-0.12,0.21l-0.28,0.48h-0.72h-0.08L71.65,57.32z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "69.23,65.17 69.23,48.5 54.8,40.17 54.8,73.5  "
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "45.81,50.61 43.73,50.61 41,47 42.48,45.89 44.65,48.77 44.84,48.77 49.54,41.97 51.06,43.02 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "60.07,61.23 57.99,61.23 63.8,52.59 66.04,52.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "63.96,61.23 66.04,61.23 60.23,52.59 57.99,52.59  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinlose);
export default __webpack_public_path__ + "static/media/winlose.978dfe21496b2be7843a5ec136d958b5.svg";
export { ForwardRef as ReactComponent };